import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { storeCostManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const storeCostManagementRouteMetadata: IRouteMetadataObj<
  typeof storeCostManagementRoutesObj
> = {
  list: {
    title: "costManagement.index.title",
    description: "empty",
    lazy: () => import("@pages/costManagement/storeCost/table/page"),
    mode: "index",
    type: "main",
    icon: "MoneyDollarCircleLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "costManagement.storeCost.create.title",
    description: "empty",
    lazy: () => import("@/pages/costManagement/storeCost/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "costManagement.storeCost.edit.title",
    description: "empty",
    lazy: () => import("@/pages/costManagement/storeCost/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EditLine",
    breadcrumbs: [],
    permission,
  },
};

export const storeCostManagementRoutes = createRoute<
  typeof storeCostManagementRoutesObj
>(storeCostManagementRoutesObj, storeCostManagementRouteMetadata);
